import type { CSSProperties } from 'react';
import { forwardRef } from 'react';
import { Layout } from '../../../types';
import { SideMediaContainer } from '../components';
import { BaseImageBlock } from './BaseImageBlock';
import type { ImageBlockProps } from './ImageBlock';

export const SideImageBlock = forwardRef<HTMLDivElement, ImageBlockProps>(
  (
    {
      src,
      layout,
      areaWidth,
      style,
      onClick,
      className,
      alt,
      scale,
      ratio,
      borderRadius,
      containerHeight
    },
    forwardingRef
  ) => {
    const isBannerLayout = [Layout.LeftBanner, Layout.RightBanner].includes(
      layout
    );

    const bannerBlockStyle: CSSProperties = isBannerLayout
      ? {
          objectFit: 'cover',
          position: 'absolute'
        }
      : {};

    const mediaStyles: CSSProperties = {
      marginInline: 'auto',
      ...bannerBlockStyle,
      ...style
    };

    return (
      <SideMediaContainer
        layout={layout}
        areaWidth={areaWidth}
        onClick={onClick}
      >
        <BaseImageBlock
          ref={forwardingRef}
          className={className}
          style={mediaStyles}
          src={src}
          alt={alt}
          scale={scale}
          ratio={ratio}
          borderRadius={borderRadius}
          containerHeight={containerHeight}
          onClick={onClick}
        />
      </SideMediaContainer>
    );
  }
);
